exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile[data-v-7fe34c1d] {\n  display: inline-block;\n}\n.notify-badge[data-v-7fe34c1d] {\n  font-size: 12px;\n  position: absolute;\n  right: 15px;\n  top: 17px;\n  background: #3db152;\n  text-align: center;\n  border-radius: 30px 30px 30px 30px;\n  color: white;\n  padding: 2px 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7fe34c1d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/LayoutSidebar.vue
// module id = coM6
// module chunks = 0